export enum DesigningTools {
    Cursor = 1,
    CursorPicker = 2,
    Rectangle = 3,
    Hand = 4,
    Ellipse = 5,
    Marker = 6,
    Pen = 7,
    Arrow = 8,
}

export enum DesigningHotkeys {
    F1 = DesigningTools.Cursor,
    F2 = DesigningTools.CursorPicker,
    F3 = DesigningTools.Rectangle,
    F4 = DesigningTools.Hand,
    F5 = DesigningTools.Ellipse,
    F6 = DesigningTools.Marker,
    F7 = DesigningTools.Pen,
    F8 = DesigningTools.Arrow,
}

export default DesigningTools;
